import * as React from 'react';
import { IOrthodonticReferralICD10Code } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralICD10CodesTable } from '../OrthodonticReferralTables/OrthodonticReferralICD10CodesTable';
import { OrthodonticReferralICD10CodesModal } from '../OrthodonticReferralModals/OrthodonticReferralICD10CodesModal';
import { ButtonType, CustomButton } from 'soprasteria-ui-library';

interface IOrthodonticReferralICD10Codes {
    orthodonticReferralICD10Codes?: IOrthodonticReferralICD10Code[];
    canAddOrthodonticReferralICD10CodeMapping: boolean;
    canDeleteOrthodonticReferralICD10CodeMapping: boolean;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
}

export const OrthodonticReferralICD10Codes: React.FunctionComponent<IOrthodonticReferralICD10Codes> = ({ orthodonticReferralICD10Codes, canAddOrthodonticReferralICD10CodeMapping, canDeleteOrthodonticReferralICD10CodeMapping, getOrthodonticReferral, orthodonticReferralId, changeSuccessMessage }) => {

    const [renderForm, setRenderForm] = React.useState<boolean>(true);

    return (
        <>
            <div className="row">
                <label className="col-6">ICD10-koder</label>
                <div className="col-6 text text-right">
                    {
                        canAddOrthodonticReferralICD10CodeMapping ?
                            <CustomButton buttonText="Lägg till ICD10-kod" buttonType={ButtonType.create} data-toggle="modal" data-target="#orthodontic-referral-icd10-codes-modal" onClick={() => setRenderForm(true)} />
                            : null
                    }
                </div>
            </div>
            <OrthodonticReferralICD10CodesTable orthodonticReferralICD10Codes={orthodonticReferralICD10Codes} canDeleteOrthodonticReferralICD10CodeMapping={canDeleteOrthodonticReferralICD10CodeMapping} changeSuccessMessage={changeSuccessMessage} getOrthodonticReferral={getOrthodonticReferral} orthodonticReferralId={orthodonticReferralId} />
            {
                canAddOrthodonticReferralICD10CodeMapping ?
                    <OrthodonticReferralICD10CodesModal
                        getOrthodonticReferral={getOrthodonticReferral}
                        changeSuccessMessage={changeSuccessMessage}
                        orthodonticReferralId={orthodonticReferralId}
                        renderForm={renderForm}
                        setRenderForm={setRenderForm} />
                    : null
            }
        </>
    )
}